import React, { useEffect, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Box, Grid } from '@mui/material';
import { Link } from 'gatsby-theme-material-ui';
import styles from './styles';

function LogosListSvg({ list }) {
  const isWidthBelowXl = useMediaQuery((theme) => theme.breakpoints.down('xl'));

  const [currentList, setCurrentList] = useState(list);

  useEffect(() => {
    if (isWidthBelowXl) {
      setCurrentList((prev) => prev.filter((item) => !item.isMobileHidden));
    } else {
      setCurrentList(list);
    }
  }, [isWidthBelowXl]);

  return (
    <Grid container>
      {currentList.map(({ IconComponent, url }) => (
        <Grid sx={styles.item} key={url} item xs={4} xl={2.2}>
          <Box
            sx={(_) => styles.imageWrapper(_, IconComponent)}
            component={url ? Link : 'div'}
            to={url}
            target={url && '_blank'}
          >
            <IconComponent tabIndex="1" sx={{ fill: 'currentColor' }} />
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}

export default LogosListSvg;
